import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_15EBlue_15DRed_SBlue = () => <CrossRoad coords="2157.000000, 1060.023281"/>;

export default CrossRoad_15EBlue_15DRed_SBlue;
